import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";

import {
  Button,
  Card,
  Col,
  IconButton,
  Row,
  Spinner,
} from "@deere/ux.uxframe-react";
import { ReactComponent as ChevronRight } from "@deere/ux.brand-foundations/icons/chevron_right.svg";
import { ReactComponent as ChevronLeft } from "@deere/ux.brand-foundations/icons/chevron_left.svg";
import { ReactComponent as ChevronDown } from "@deere/ux.brand-foundations/icons/chevron_down.svg";

import {
  claimList,
  claimListFromClaimSearchForm,
  claimsLoading,
  getClaims,
} from "./claimSearchSlice";
import ExportClaimDetails from "../export-to-excel/ExportClaimDetails";
import { languageResponseData } from "../Translation/translationSerachSlice";

import { printContentById } from "../common/PrintUtils";

const ClaimDetails = () => {
  const translationsResponse = useSelector(languageResponseData);
  const translate = (key, defaultText) => {
    return translationsResponse[key] || defaultText;
  };

  const dispatch = useDispatch();
  const history = useHistory();

  const claims = useSelector(claimList);
  const claimsFromClaimSearch = useSelector(claimListFromClaimSearchForm);
  const location = useLocation();
  const claimListLoading = useSelector(claimsLoading);

  const { claimNumber } = useParams();

  const searchFrom = location.state?.searchFrom;
  let claim = claims.find((claim) => claim?.claimNumber === claimNumber);
  let currentClaimIndex = claims.findIndex(
    (claim) => claim?.claimNumber === claimNumber
  );

  if (claims.length === 0) {
    claim = claimsFromClaimSearch.find(
      (claim) => claim?.claimNumber === claimNumber
    );
  }

  const [collapsibleSections, setCollapsibleSections] = useState({
    failurePartVisible: true,
    creditsVisible: true,
    complaintsVisible: true,
    causeVisible: true,
    correctionVisible: true,
  });

  if (searchFrom === "ClaimSearchForm") {
    claim = claimsFromClaimSearch.find(
      (claim) => claim?.claimNumber === claimNumber
    );
    currentClaimIndex = claimsFromClaimSearch.findIndex(
      (claim) => claim?.claimNumber === claimNumber
    );
  }

  const onCollapseCard = (cardName) => {
    setCollapsibleSections({
      ...collapsibleSections,
      [cardName]: !collapsibleSections[cardName],
    });
  };

  let currentIndex, nextIndex;
  const viewNextClaim = () => {
    if (searchFrom === "ClaimSearchForm" && claimsFromClaimSearch.length > 1) {
      currentIndex = claimsFromClaimSearch.findIndex(
        (claim) => claim?.claimNumber === claimNumber
      );
      nextIndex = (currentIndex + 1) % claimsFromClaimSearch.length;
      claim = claimsFromClaimSearch[nextIndex];
      /*setClaimIndex(nextIndex);
            setClaimObject(claim);*/
      history.replace({
        pathname: `/claim-search/claimNumber/${claim.claimNumber}`,
        state: {
          searchFrom: searchFrom,
        },
      });
    } else if (claims.length > 1) {
      currentIndex = claims.findIndex(
        (claim) => claim?.claimNumber === claimNumber
      );
      nextIndex = (currentIndex + 1) % claims.length;
      claim = claims[nextIndex];
      /*setClaimIndex(nextIndex);
            setClaimObject(claim);*/
      history.replace({
        pathname: `/claim-search/claimNumber/${claim.claimNumber}`,
        state: {
          searchFrom: searchFrom,
        },
      });
    }
  };
  const viewPreviousClaim = () => {
    if (searchFrom === "ClaimSearchForm" && claimsFromClaimSearch.length > 1) {
      currentIndex = claimsFromClaimSearch.findIndex(
        (claim) => claim?.claimNumber === claimNumber
      );
      nextIndex =
        (currentIndex - 1 + claimsFromClaimSearch.length) %
        claimsFromClaimSearch.length;
      claim = claimsFromClaimSearch[nextIndex];
      history.replace({
        pathname: `/claim-search/claimNumber/${claim.claimNumber}`,
        state: {
          searchFrom: searchFrom,
        },
      });
    } else if (claims.length > 1) {
      currentIndex = claims.findIndex(
        (claim) => claim?.claimNumber === claimNumber
      );
      nextIndex = (currentIndex - 1 + claims.length) % claims.length;
      claim = claims[nextIndex];
      history.replace({
        pathname: `/claim-search/claimNumber/${claim.claimNumber}`,
        state: {
          searchFrom: searchFrom,
        },
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
    if (claim === undefined) {
      const searchObjclaim = {
        searchType: "ClaimNumber",
        pin: "",
        claimNumber: claimNumber,
        searchFrom: "claimSearchForm",
      };
      dispatch(getClaims(searchObjclaim));
    }
  }, []);

  return (
    <div>
      {/*Added Buttons for print to pdf and Export to Excel*/}
      <Row
        style={{
          marginBottom: "1rem",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          variant="secondary"
          onClick={() =>
            printContentById("claim-details-data", "Claim Details")
          }
        >
          {translate("print_to_pdf", "Print to Pdf")}
        </Button>{" "}
        &nbsp; &nbsp;
        <ExportClaimDetails claim={claim} />
      </Row>
      <div id="claim-details-data">
        {/*Claim Details*/}
        {claimListLoading ? (
          <div className="d-flex w-100 justify-content-center align-items-center">
            <Spinner
              accessibilityLabel="Loading"
              className="uxf-spinner-border-lg"
              animation="border"
            />
          </div>
        ) : (
          <>
            {claim && (
              <div>
                <div className="exclude-from-print">
                  <Row>
                    <Col>
                      <p style={{ textAlign: "right" }}>
                        <IconButton ariaLabel={""} onClick={viewPreviousClaim}>
                          <ChevronLeft />
                        </IconButton>
                      </p>
                    </Col>
                    <p>{currentClaimIndex + 1}</p>
                    <Col>
                      <p style={{ textAlign: "left" }}>
                        <IconButton ariaLabel={""} onClick={viewNextClaim}>
                          <ChevronRight />
                        </IconButton>
                      </p>
                    </Col>
                  </Row>
                </div>
                <Card>
                  <Card.Header>
                    <strong>
                      {translate("basic_claim_details", "Basic Claim Details")}
                    </strong>
                  </Card.Header>
                  <Card.Body style={{ fontSize: ".8rem" }}>
                    <Row>
                      <Col sm="8">
                        {claim && (
                          <dl className="uxf-dl">
                            <dt>{translate("claim_number", "Claim Number")}</dt>
                            <dd>{claim.claimNumber}</dd>
                            <dt>
                              {translate(
                                "claim_sequence_no",
                                "Claim Sequence Number"
                              )}
                            </dt>
                            <dd>{claim.claimSequenceNumber}</dd>
                            <dt>{translate("claim_type", "Claim Type")}</dt>
                            <dd>{claim.claimType}</dd>
                            <dt>{translate("dealer_ac", "Dealer Account")}</dt>
                            <dd>{claim.dealer.dealerNumber}</dd>
                            <dt>{translate("customer", "Customer")}</dt>
                            <dd>{claim.customerName}</dd>
                            <dt>
                              {translate(
                                "ownership_status",
                                "Ownership Status"
                              )}
                            </dt>
                            <dd>{claim.ownershipStatus}</dd>
                          </dl>
                        )}
                      </Col>
                      <Col sm="8">
                        {claim && (
                          <dl className="uxf-dl">
                            <dt>{translate("pin", "Pin #")}</dt>
                            <dd>
                              <Link
                                to={{
                                  pathname: `/machine-details/pin/${claim.pinNumber}`,
                                  state: { machineSearchType: "machines" },
                                }}
                              >
                                {claim.pinNumber}
                              </Link>
                            </dd>
                            <dt>{translate("model", "Model")}</dt>
                            <dd>{claim.model}</dd>
                            <dt>{translate("measurement", "Measurement")}</dt>
                            <dd>{claim.measurement ?? 0} Hrs</dd>
                            <dt>{translate("reference #1", "Reference #1")}</dt>
                            <dd>{claim.reference1}</dd>
                            <dt>{translate("reference #2", "Reference #2")}</dt>
                            <dd>{claim.reference2}</dd>
                            <dt>{translate("credit_memo", "Credit Memo")}</dt>
                            <dd>{claim.creditMemo}</dd>
                          </dl>
                        )}
                      </Col>
                      <Col sm="8">
                        {claim && (
                          <dl className="uxf-dl">
                            <dt>
                              {translate(
                                "failure_part_serial",
                                "Failure Part Serial #"
                              )}
                            </dt>
                            <dd>{claim.failurePartSerialNumber}</dd>
                            <dt>{translate("failure_date", "Failure Date")}</dt>
                            <dd>{claim.failureDate}</dd>
                            <dt>{translate("repair_date", "Repair Date")}</dt>
                            <dd>{claim.repairDate}</dd>
                            <dt>{translate("process_date", "Process Date")}</dt>
                            <dd>{claim.processDate}</dd>
                          </dl>
                        )}
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
                <Card>
                  <Card.Header>
                    <strong>
                      {translate("failure_info", "Failure Information")}
                    </strong>
                  </Card.Header>
                  <Card.Body style={{ fontSize: ".8rem" }}>
                    <Card>
                      <Card.Header
                        onClick={() => onCollapseCard("failurePartVisible")}
                      >
                        {collapsibleSections.failurePartVisible ? (
                          <ChevronDown />
                        ) : (
                          <ChevronRight />
                        )}
                        {translate("failure_part", "Failure Part")}:
                        {claim.failurePartSerialNumber}
                        {/* {`Failure Part: ${claim.failurePartSerialNumber}`}*/}
                      </Card.Header>
                      {collapsibleSections.failurePartVisible && (
                        <Card.Body>
                          <Row>
                            <Col sm={12}>
                              {claim && (
                                <dl className="uxf-dl">
                                  <dt>
                                    {translate("failure_mode", "Failure Mode")}
                                  </dt>
                                  <dd>
                                    {Array.isArray(claim.failureMode)
                                      ? claim.failureMode[0]
                                      : ""}
                                  </dd>
                                  <dt>
                                    {translate("failure_area", "Failure Area")}
                                  </dt>
                                  <dd>
                                    {Array.isArray(claim.failureArea)
                                      ? claim.failureArea[0]
                                      : ""}
                                  </dd>
                                  <dt>
                                    {translate(
                                      "failure_mode_comments",
                                      "Failure Mode Comments"
                                    )}
                                  </dt>
                                  <dd>
                                    {Array.isArray(claim.failureModeComments)
                                      ? claim.failureModeComments[0]
                                      : ""}
                                  </dd>
                                  <dt>{translate("downtime", "Downtime")}</dt>
                                  <dd>
                                    {Array.isArray(claim.downtime)
                                      ? claim.downtime[0]
                                      : ""}
                                  </dd>
                                </dl>
                              )}
                            </Col>
                            <Col sm={12}>
                              {claim && (
                                <dl className="uxf-dl">
                                  <dt>
                                    {translate(
                                      "prevoius_invoice",
                                      "Previous Invoice #"
                                    )}
                                  </dt>
                                  <dd></dd>
                                  <dt>
                                    {translate(
                                      "test_results_code",
                                      "Test Results Code"
                                    )}
                                  </dt>
                                  <dd></dd>
                                  <dt>{translate("dtac_case", "DTAC Case")}</dt>
                                  <dd>
                                    {Array.isArray(claim.dtacCaseNumber)
                                      ? claim.dtacCaseNumber[0]
                                      : ""}
                                  </dd>
                                  <dt>
                                    {translate(
                                      "dtac_solutions",
                                      "DTAC Solution"
                                    )}
                                  </dt>
                                  <dd>
                                    {Array.isArray(claim.dtacSolution)
                                      ? claim.dtacSolution[0]
                                      : ""}
                                  </dd>
                                </dl>
                              )}
                            </Col>
                          </Row>
                        </Card.Body>
                      )}
                    </Card>
                    <Card>
                      <Card.Header
                        onClick={() => onCollapseCard("creditsVisible")}
                      >
                        {collapsibleSections.creditsVisible ? (
                          <ChevronDown />
                        ) : (
                          <ChevronRight />
                        )}
                        {translate(
                          "parts_labor",
                          "Parts / Labor / Other Credits"
                        )}
                      </Card.Header>
                      {collapsibleSections.creditsVisible && (
                        <Card.Body>
                          {claim && creditTable(claim, translate)}
                        </Card.Body>
                      )}
                    </Card>

                    <Card>
                      <Card.Header
                        onClick={() => onCollapseCard("complaintsVisible")}
                      >
                        {collapsibleSections.complaintsVisible ? (
                          <ChevronDown />
                        ) : (
                          <ChevronRight />
                        )}
                        {translate("complaint", "Complaint")}
                      </Card.Header>
                      {collapsibleSections.complaintsVisible && (
                        <Card.Body>
                          <p>
                            {Array.isArray(claim.complaint)
                              ? claim.complaint[0]
                              : ""}
                          </p>
                        </Card.Body>
                      )}
                    </Card>
                    <Card>
                      <Card.Header
                        onClick={() => onCollapseCard("causeVisible")}
                      >
                        {collapsibleSections.causeVisible ? (
                          <ChevronDown />
                        ) : (
                          <ChevronRight />
                        )}
                        {translate("cause", "Cause")}
                      </Card.Header>
                      {collapsibleSections.causeVisible && (
                        <Card.Body>
                          <p>
                            {Array.isArray(claim.cause) ? claim.cause[0] : ""}
                          </p>
                        </Card.Body>
                      )}
                    </Card>
                    <Card>
                      <Card.Header
                        onClick={() => onCollapseCard("correctionVisible")}
                      >
                        {collapsibleSections.correctionVisible ? (
                          <ChevronDown />
                        ) : (
                          <ChevronRight />
                        )}
                        {translate("correction", "Correction")}
                      </Card.Header>
                      {collapsibleSections.correctionVisible && (
                        <Card.Body>
                          <p>
                            {Array.isArray(claim.correction)
                              ? claim.correction[0]
                              : ""}
                          </p>
                        </Card.Body>
                      )}
                    </Card>
                  </Card.Body>
                </Card>
              </div>
            )}
          </>
        )}
      </div>
      <Row
        style={{
          marginBottom: "1rem",
          marginTop: "1rem",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          variant="secondary"
          onClick={() =>
            printContentById("claim-details-data", "Claim Details")
          }
        >
          {translate("print_to_pdf", "Print to Pdf")}
        </Button>{" "}
        &nbsp; &nbsp;
        <ExportClaimDetails claim={claim} />
      </Row>
    </div>
  );
};

const creditTable = (claim) => {
  return (
    <div className="table-responsive">
      <table className="table table-sm table-uxf-modern">
        <thead>
          <tr>
            <th scope="col">Item</th>
            <th scope="col">Description</th>
            <th scope="col">Quantity Approved</th>
          </tr>
        </thead>
        <tbody>
          {claim.claimReplacementPartList.map((part, index) => {
            return (
              <tr key={index}>
                <td>{part.rplc_part_num}</td>
                <td>{part.part_name_dsc}</td>
                <td>{part.requested_part_cnt}</td>
              </tr>
            );
          })}
          <tr>
            <td colSpan="3"></td>
          </tr>
          {claim.laborList.map((labor, index) => {
            return (
              <tr key={index}>
                <td>{labor.laborNumber}</td>
                <td>{labor.laborDescription}</td>
                <td>{labor.quantityApproved}</td>
              </tr>
            );
          })}
          <tr>
            <td colSpan="3"></td>
          </tr>
          {claim.otherCreditsList?.map((credit, index) => {
            return (
              <tr key={index}>
                <td colSpan={3}>credit</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ClaimDetails;
